module.exports = __webpack_public_path__ + "img/lactose.57fa6b17.svg";